import { defineMessages } from 'react-intl';

export default defineMessages({
  // Payment confirmation
  manualEntryTitle: {
    id: 'cc4.form.client-account.subscription-manual-entry-header-return',
    defaultMessage: 'Tell us about your return trip',
  },
  manualEntryDepartureTitle: {
    id: 'cc4.form.client-account.subscription-manual-entry-header-departure',
    defaultMessage: 'Tell us about your departure trip',
  },
  manualEntrySubTitle: {
    id: 'cc4.form.client-account.subscription-manual-entry-sub-header',
    defaultMessage:
      'Share the trip you want to add to premium by uploading the booking confirmation',
  },
  backButton: {
    id: 'cc4.form.client-account.subscription-back-button',
    defaultMessage: 'Back',
  },
  tripOverviewTitle: {
    id: 'cc4.form.client-account.trip-overview-title',
    defaultMessage: 'Trip overview',
  },
  noTripsLabel: {
    id: 'cc4.form.client-account.trip-overview-no-trips-button-label',
    defaultMessage: 'Protect first trip',
  },
  noTripsHeader: {
    id: 'cc4.form.client-account.trip-overview-no-trips-header',
    defaultMessage: 'No trips added yet',
  },
  uploadSubHeader: {
    id: 'cc4.form.client-account.trip-overview-no-trips-subheader',
    defaultMessage: 'Upload your future trips and protect them',
  },
  uploadSubText: {
    id: 'cc4.form.client-account.trip-overview-no-trips-label',
    defaultMessage: 'Only trips that are 40 hours in advance are eligible',
  },
  uploadBookingConfirmationLabel: {
    id: 'cc4.form.client-account.trip-overview-options-upload-logo-label',
    defaultMessage: 'Uploading your booking confirmation',
  },
  uploadFiveMinsLabel: {
    id: 'cc4.form.client-account.trip-overview-options-upload-sub-label',
    defaultMessage: 'It only takes you 5 minutes',
  },
  startUploading: {
    id: 'cc4.form.client-account.trip-overview-options-upload-button-label',
    defaultMessage: 'Start by uploading',
  },
  manualEntry: {
    id: 'cc4.form.client-account.trip-overview-options-manual-label',
    defineMessage: 'Manual entry',
  },
  optionsManualSubLabel: {
    id: 'cc4.form.client-account.trip-overview-options-manual-sub-label',
    defaultMessage: 'Still fast, just manual input',
  },
  startManualLabel: {
    id: 'cc4.form.client-account.trip-overview-options-manual-button-label',
    defaultMessage: 'Start manual',
  },
  optionUploadLabel: {
    id: 'cc4.form.client-account.trip-overview-options-upload-header',
    defaultMessage: 'Choose how to protect your trip',
  },
  subscriptionFlightDate: {
    id: 'cc4.client-account.subscription-flight-date',
    defaultMessage: 'Flight date:',
  },
  subscriptionFlightNr: {
    id: 'cc4.client-account.subscription-flight-nr',
    defaultMessage: 'Flight nr:',
  },
  analysingFile: {
    id: 'cc4.client-account.subscription-uploading-loading-message',
    defaultMessage: 'Analysing document',
  },

  uploadFileText: {
    id: 'cc4.client-account.subscription-uploading-text',
    defaultMessage:
      'Browser or drag your booking confirmation you want to upload from your computer',
  },
  uploadButton: {
    id: 'cc4.client-account.subscription-uploading-button',
    defaultMessage: 'Upload document',
  },
  flightsFoundLabel: {
    id: 'cc4.client-account.subscription-flights-found-label',
    defaultMessage: 'Flights found',
  },
  enterManuallyLable: {
    id: 'cc4.client-account.subscription-enter-manual-label',
    defaultMessage: 'Enter manually',
  },
  wrongLabel: {
    id: 'cc4.client-account.subscription-wrong-label',
    defaultMessage: 'Something wrong',
  },
  saveTripsLabel: {
    id: 'cc4.client-account.subscription-save-trip-label',
    defaultMessage: 'Save trips to my account',
  },
  protectNewTripLabel: {
    id: 'cc4.client-account.subscription-protect-new-trip-label',
    defaultMessage: 'Protect a new trip',
  },
  continueButton: {
    id: 'cc4.client-account.subscription-continue-button',
    defaultMessage: 'Continue',
  },
  yourSubscriptionLabel: {
    id: 'cc4.client-account.subscription-your-subscription-label',
    defaultMessage: 'Your subscription',
  },
  finalDestinationLabel: {
    id: 'cc4.client-account.subscription-final-label',
    defaultMessage: 'Final destination',
  },
  stoppoverLabel: {
    id: 'cc4.client-account.subscription-stoppover-label',
    defaultMessage: 'Stoppover in:',
  },
  nextLabel: {
    id: 'cc4.client-account.subscription-next-label',
    defaultMessage: 'Next',
  },
  infoLabel: {
    id: 'cc4.client-account.subscription-info-label',
    defaultMessage: 'Information needed to protect your trip',
  },
  routeLabel: {
    id: 'cc4.client-account.subscription-route-label',
    defaultMessage: 'Tell us about your route',
  },
  shareInfoLabel: {
    id: 'cc4.client-account.subscription-share-info',
    defaultMessage: 'Share the flight information',
  },
  premiumLabel: {
    id: 'cc4.client-account.subscription-my-premium-label',
    defaultMessage: 'Premium',
  },
  priceLabel: {
    id: 'cc4.client-account.subscription-my-premium-price',
    defaultMessage: '29,99 euro/year (VAT included)',
  },
  billedLabel: {
    id: 'cc4.client-account.subscription-my-premium-billed',
    defaultMessage: 'Billed yearly',
  },
  nextPayment: {
    id: 'cc4.client-account.subscription-my-premium-next-payment',
    defaultMessage: 'Next payment',
  },
  compensationLabel: {
    id: 'cc4.client-account.subscription-my-premium-claim-compensation-label',
    defaultMessage: 'Claim compensation',
  },
  autoRenewLabel: {
    id: 'cc4.client-account.subscription-my-renew-label',
    defaultMessage: 'Cancel auto-renew',
  },
  planLabel: {
    id: 'cc4.client-account.subscription-my-plan',
    defaultMessage: 'Plan',
  },
  howWorksTitle: {
    id: 'cc4.client-account.subscription-buy-how-work-title',
    defaultMessage: 'How does it work?',
  },
  premiumSubscribeTitle: {
    id: 'cc4.client-account.subscription-buy-how-subscribe-title',
    defaultMessage: 'Subscribe to premium',
  },
  bookFlightTitle: {
    id: 'cc4.client-account.subscription-buy-how-book-title',
    defaultMessage: 'Book a flight',
  },
  compensationTitle: {
    id: 'cc4.client-account.subscription-buy-how-compensation-title',
    defaultMessage: 'Get compensation',
  },
  buyInfoTitle: {
    id: 'cc4.client-account.subscription-buy-info-tilte',
    defaultMessage: 'Peace of mind when traveling',
  },
  buyInfoSubtitle: {
    id: 'cc4.client-account.subscription-buy-info-sub-tilte',
    defaultMessage:
      'Say goodbye to flight compensation with commission. Flight Delayed Premium helps you get your compensation faster',
  },
  becomePremiumButton: {
    id: 'cc4.client-account.subscription-buy-info-button',
    defaultMessage: 'Become premium',
  },
  bubbleLabel: {
    id: 'cc4.client-account.subscription-buy-banner-bubble',
    defaultMessage: 'No commission claims!',
  },
  bannerTitle: {
    id: 'cc4.client-account.subscription-buy-banner-title',
    defaultMessage: 'Hi {name} protect your future delayed or cancellations',
  },
  bannerSubTitle: {
    id: 'cc4.client-account.subscription-buy-banner-sub-title',
    defaultMessage:
      'With Fligh-Delayed Premium you have 0% commission on eligible claims for 12 months! Perfect for frequent flyers or casual travelers',
  },
  bannerFooter: {
    id: 'cc4.client-account.subscription-buy-banner-footer-text',
    defaultMessage: 'You will be protected for 12 months',
  },
  howWorksPremium: {
    id: 'cc4.client-account.subscription-buy-how-work-content',
    defaultMessage:
      'In just 1 minute you can create your account and connect the premium',
  },
  bookFlightContent: {
    id: 'cc4.client-account.subscription-buy-book-flight-content',
    defaultMessage:
      'Link upcoming trips in your Flight-Delayed premium account',
  },
  compensationContent: {
    id: 'cc4.client-account.subscription-buy-how-compensation-content',
    defaultMessage:
      'When your flight got cancelled or delayed we help you get compensation',
  },
  paymentCancelledStatus: {
    id: 'cc4.client-account.subscription-payment-cancelled-status-title',
    defaultMessage: 'Payment Cancelled',
  },
  paymentCancelledStatusText: {
    id: 'cc4.client-account.subscription-payment-cancelled-status-text',
    defaultMessage:
      'The payment has been cancelled, you have not paid yet and also have no Premium account. To get your premium account please try again',
  },
  paymentCancelledStatusButtonText: {
    id: 'cc4.client-account.subscription-payment-cancelled-status-button-text',
    defaultMessage: 'Retry payment',
  },
  paymentSuccessStatus: {
    id: 'cc4.client-account.subscription-payment-success-status-title',
    defaultMessage: 'Payment Successful',
  },
  paymentSuccessStatusText: {
    id: 'cc4.client-account.subscription-payment-success-status-text',
    defaultMessage:
      'Your payment has been received succesfully and your account is active',
  },
  paymentSuccessStatusButtonText: {
    id: 'cc4.client-account.subscription-payment-success-status-button-text',
    defaultMessage: 'Go to account',
  },
  paymentPendingStatus: {
    id: 'cc4.client-account.subscription-payment-pending-status-title',
    defaultMessage: 'Payment Pending',
  },
  paymentPendingStatusText: {
    id: 'cc4.client-account.subscription-payment-pending-status-text',
    defaultMessage:
      'Your payment has been received succesfully and your account is active',
  },
  paymentPendingStatusButtonText: {
    id: 'cc4.client-account.subscription-payment-pending-status-button-text',
    defaultMessage:
      "We are processing your payment, this can take a minute. Don't reload this page",
  },
  uploadingNoFlightsError: {
    id: 'cc4.client-account.subscription-uploading-no-flights-notification',
    defaultMessage:
      'Unfortunately, we were not able to retrieve your flight data from this file. Please double-check whether you have uploaded the correct file or provide flight data manually',
  },
  bannerMobileTitle: {
    id: 'cc4.client-account.subscription-banner-mobile-title',
    defaultMessage: 'Protect future flights',
  },
  bannerPriceButtonLabel: {
    id: 'cc4.client-account.subscription-banner-button-label',
    defaultMessage: 'See our pricing',
  },
  credidBannerText: {
    id: 'cc4.client-account.subscription-credit-banner-label',
    defaultMessage:
      'Your credits will stay active till {date} and are only used for eligible claims',
  },
  credidBannerHeader: {
    id: 'cc4.client-account.subscription-credit-banner-header',
    defaultMessage: 'Premium credits',
  },
  loungeAccessHeader: {
    id: 'cc4.client-account.subscription-lounge-access-header',
    defaultMessage: 'Lounge access',
  },
  loungeAccessDescription: {
    id: 'cc4.client-account.subscription-lounge-access-desc',
    defaultMessage:
      'One of your flights had a delay. Below you can download the QR code for business lounge.',
  },
  loungeAccessHideButton: {
    id: 'cc4.client-account.subscription-lounge-access-hide-button',
    defaultMessage: 'Hide QR code',
  },
  loungeAccessShowButton: {
    id: 'cc4.client-account.subscription-lounge-access-show-button',
    defaultMessage: 'Show QR code',
  },
  loungeAccesDate: {
    id: 'cc4.client-account.subscription-lounge-access-date',
    defaultMessage: 'QR code from {date}',
  },
  availableLounges: {
    id: 'cc4.client-account.subscription-lounge-available-label',
    defaultMessage: 'Available lounges',
  },
  openingHours: {
    id: 'cc4.client-account.subscription-lounge-opening-hours-label',
    defaultMessage: 'Opening hours',
  },
  hours48FlightsError: {
    id:
      'cc4.client-account.subscription-uploading-48-hours-flights-notification',
    defaultMessage:
      'This flight is not eligible for the Premium coverage. Your Premium covers only flights between {subscription_start_date} to {subscription_end_date} and the flight data must be provided at least 48 hours before the departure',
  },
  repeatedFlightError: {
    id:
      'cc4.client-account.subscription-flight-already-added-to-other-trip-notification',
    defaultMessage: 'This flight has already been added to another trip.',
  },
  bannerCredits: {
    id: 'cc4.client-account.subscription-credit-banner-credits',
    defaultMessage: '{remainingCredit} of {totalCredits}',
  },
  premiumDeadline: {
    id: 'cc4.client-account.subscription-premium-end-date-label',
    defaultMessage: 'You can use premium until',
  },
  cancelledAutoRenewalMsg: {
    id: 'cc4.client-account.subscription-cancelled-auto-renewal-text',
    defaultMessage:
      'You cancelled auto-renewal, so your Premium access will end on the date above',
  },
  vipLoungeLabel: {
    id: 'cc4.client-account.subscription-vip-lounge-label',
    defaultMessage: 'VIP Lounge',
  },
  cancelAutoRenewTitleModal: {
    id: 'cc4.client-account.subscription-auto-renewal-modal-title',
    defaultMessage: 'Are you sure you want to cancel your auto-renew?',
  },
  cancelAutoRenewSubTitleModal: {
    id: 'cc4.client-account.subscription-auto-renewal-modal-subtitle',
    defaultMessage: 'This is what you will be missing',
  },
});
